import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-schis2hiv',
  templateUrl: './schis2hiv.component.html',
  styleUrls: ['./schis2hiv.component.scss']
})
export class Schis2hivComponent implements OnInit {

  exposition: CardContent = {
    title: 'Schis-2-HIV',
    subtitle: 'A pandemic influenza preparedness planning tool',
    image_source: 'assets/images/Schis-2-HIV.PNG',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Clients / Partners</h4>Epimos, WHO, BMGF',
      '<h4>Methods</h4>Stochastic Individual-based Modelling',
      '<h4>Technology / Skills</h4>Discrete Event Simulation, Java, Swing',
      '<h4>Term</h4>2013',
    ]
  };

  constructor() { }

  ngOnInit(): void {
  }

}
